import React from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

const SELECTS = require('../Datas/Selects')

const BonsPLansJeunesFormFilterPublics = ({ 
	bonsPLansJeunesFilterFilterActivePublics, 
	OnChangeFilterPublics, 
	AgendaFilterActiveOther 
}) => {
	// Validation des props
	if (!OnChangeFilterPublics || typeof OnChangeFilterPublics !== 'function') {
		return null;
	}

	if (!SELECTS || !SELECTS['publics'] || !Array.isArray(SELECTS['publics'])) {
		return null;
	}

	return (
		<div 
			className="bons-plans-jeunes-filter-publics-container generic-filters-select generic-filters-select-publics"
			role="group"
			aria-label="Filtre par public pour les bons plans jeunes"
			aria-describedby="filter-publics-description"
		>
			<div id="filter-publics-description" className="visually-hidden">
				Sélectionnez le public cible pour filtrer les bons plans jeunes
			</div>
			<Select 
				className="bons-plans-jeunes-filters-select bons-plans-jeunes-filters-select-publics" 
				name="agenda-filters-category" 
				placeholder="Public" 
				options={SELECTS['publics']} 
				onChange={OnChangeFilterPublics}
				value={bonsPLansJeunesFilterFilterActivePublics}
				simpleValue
				clearable={false}
				searchable={false}
				aria-label="Sélection du public cible"
				aria-describedby="filter-publics-description"
			/>
		</div>
	);
};

export default BonsPLansJeunesFormFilterPublics
